import { Action, createLogic, Logic } from "redux-logic";
import { Observable } from "rxjs";

import { actions as notificationActions, actionTypes as notificationTypes } from "reducer/notification";

import { getNotificationsCount, getNotificationsList } from "api/notification/notification";

import { calculateMaxPage } from "utils/calculateMaxPage";

import { ITEMS_PER_PAGE, UPDATE_EVERY } from "consts/notification";

import { IRootState } from "reducer";

import { PagingListParams } from "types/api";
import { NotificationResponse } from "types/notification";
import { Canceler } from "axios";

const notificationCount = createLogic({
    type: notificationTypes.GET_COUNT,
    latest: false,
    warnTimeout: 0,

    async process({getState, action$}: { getState: () => IRootState, action$: Observable<Action> }, dispatch, done) {
        const getCount = () => getNotificationsCount()
            .then(count => {
                if (count !== null) {
                    dispatch(notificationActions.getCountSuccess({count}));
                }
                if (getState().user.isLogged) {
                    setTimeout(getCount, UPDATE_EVERY * 1000)
                }
            });
        getCount();
    }
});

let prevRequestCanceler: undefined | Canceler;

const notificationList = createLogic({
    type: notificationTypes.GET_LIST,
    latest: false,
    warnTimeout: 0,



    async process({action, getState}: { action: { type: string; payload: PagingListParams }, getState: () => IRootState }, dispatch, done) {
        if (prevRequestCanceler) {
            prevRequestCanceler();
        }
        const listRequest = getNotificationsList({...action.payload, type: getState().notification.viewMode});
        prevRequestCanceler = listRequest.cancel;
        listRequest.request
            .then(({isSuccess, data}: { isSuccess: boolean; data: NotificationResponse }) => {
            if (isSuccess) {
                const newList = getState().notification.newList;
                dispatch(notificationActions.getListSuccess({
                    list: data.list,
                    totalCount: data.count,
                    maxPage: calculateMaxPage(data.count, ITEMS_PER_PAGE),
                    newList: [...newList, ...data.new_list],
                }))
            } else {
                dispatch(notificationActions.getListFailure())
            }
            });
    }
});

export default [
    notificationCount,
    notificationList
] as Logic[];
